import React from 'react'
import { Joints, jointKeyToShortName } from '../utils/pose'
import { HealthBar } from './HealthBar'

export interface JointAngle {
  angle: number;
  conf: number;
}

export interface JointBarsProps {
  /** Joint angles data */
  jointAngles: Record<string, JointAngle>;
  /** Whether to show joint bars (for debugging) */
  showJointBars?: boolean;
  /** Custom CSS class */
  className?: string;
  /** Custom styles */
  style?: React.CSSProperties;
}

/**
 * Remaps a value from one range to another.
 * @param value - Value to remap
 * @param fromMin - Source range minimum
 * @param fromMax - Source range maximum
 * @param toMin - Target range minimum
 * @param toMax - Target range maximum
 * @returns Remapped value
 */
function remap (value: number, fromMin: number, fromMax: number, toMin: number, toMax: number): number {
  // First normalize the value from the input range to 0-1
  const normalized = (value - fromMin) / (fromMax - fromMin)

  // Then scale to output range
  return normalized * (toMax - toMin) + toMin
}

export const JointBars: React.FC<JointBarsProps> = ({
  jointAngles,
  className = '',
  style = {},
}) => {
  if (!jointAngles) {
    return null
  }

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        // position: 'absolute',
        // top: '4px',
        // left: '4px',
        zIndex: 1000,
        pointerEvents: 'none',
        ...style,
      }}
    >
      {Object.keys(Joints).map((key) => {
        const jointAngle = jointAngles[key]
        if (!jointAngle) return null

        const name = jointKeyToShortName(key)
        const angle = jointAngle.angle
        const conf = jointAngle.conf

        // Remap angle from 0-180 degrees to 0-100 for progress bar
        const progress = remap(angle, 0, 180, 0, 100)

        const text = `${name}: ${angle.toFixed(1).padStart(5, '0')}° (conf: ${conf.toFixed(2).padStart(5, ' ')})`

        return (
          <HealthBar
            key={key}
            progress={progress}
            text={text}
            width={220}
            height={16}
            showCursor={false}
          />
        )
      })}
    </div>
  )
}

export default JointBars
